import { createProvider } from "../../constants/EIP1193";
import { fetchNFTsMetadataBackend } from "../backendHelpers";
import { eventTracker } from "../eventTracker";
import { getTokensOfAddressFromAlchemy } from "./alchemyBalance";
import { getTokensOfAddressFromChain } from "./chainBalance";
import { ContractBase, CurrencyWithExchanges, ItemMap, ListOwnedNFTElement, WalletBalance } from "./commonInterfacesAndEnums";





export async function fetchBalance(walletAddress: string, setTokenData: any, _mergeTokensData: any ): Promise<WalletBalance> {

    // Accept reponse from backend which contains list of contracts and tokeMetadata
    const balanceMetadataResponse = await fetchNFTsMetadataBackend(walletAddress);
    console.log('entered 1', balanceMetadataResponse)

    const contractMap: ItemMap<ContractBase> = {};
    let tokensArr: ListOwnedNFTElement[] = [];
    let contractsArr: ContractBase[] = [];


    if (balanceMetadataResponse) {
        // Fetches balance from Chain
        const balanceFromChain = await getTokensOfAddressFromChain (
            walletAddress, walletAddress,
            (balanceMetadataResponse.coins.currencies || []),
            balanceMetadataResponse.coins.tokenMetadatas,
            balanceMetadataResponse.coins.contracts,
            (balanceMetadataResponse.coins.currencyMap || {}),
            setTokenData, _mergeTokensData);

        // Fetches balance from Alchemy
        const balanceFromAlchemy = await getTokensOfAddressFromAlchemy(walletAddress, balanceMetadataResponse.nfts.contracts, true, setTokenData, _mergeTokensData);


        // Combine from all sources
        // tokensArr = [ ...balanceMetadataResponse.coins.tokens, ...balanceMetadataResponse.nfts.tokens, ...balanceFromChain.tokens, ...balanceFromAlchemy.tokens ];
        // contractsArr = [ ...balanceMetadataResponse.coins.contracts, ...balanceMetadataResponse.nfts.contracts, ...balanceFromChain.contracts, ...balanceFromAlchemy.contracts ];


        // contractsArr.forEach( ( contract: ContractBase ) => {
        //     if (contract.id) contractMap[ contract.id ] = contract;
        // } );

        // // Sort array of tokens by id for showing consistently on UI
        // // Token id may be missing, use tokenId (the nft's on chain token id instead)
        // tokensArr = tokensArr.sort( ( a, b ) => ( a.token.id ? a.token.id : a.token.tokenId ).localeCompare( b.token.id ? b.token.id : b.token.tokenId ) );

        // eventTracker('user_balance', balanceMetadataResponse);
        // console.log(tokensArr);

    }

    return {
        contracts: contractMap,
        tokens: tokensArr,
        currencies: (balanceMetadataResponse && balanceMetadataResponse.coins && balanceMetadataResponse.coins.currencyMap) 
                        ? 
                        balanceMetadataResponse.coins.currencyMap 
                        : {} as ItemMap<CurrencyWithExchanges>
    }
    
}



